import { render, staticRenderFns } from "./BettingArea.vue?vue&type=template&id=2755e198&scoped=true"
import script from "./BettingArea.vue?vue&type=script&lang=js"
export * from "./BettingArea.vue?vue&type=script&lang=js"
import style0 from "./BettingArea.vue?vue&type=style&index=0&id=2755e198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2755e198",
  null
  
)

export default component.exports